// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"625":"c9949364","865":"c9949364","2717":"c9949364","2917":"c9949364","3336":"c9949364","8786":"c9949364"}[chunkId] + ".chunk.css";
};